class Loader {
  constructor() {
    this.paths = {};
  }

  load(path) {
    if (!this.paths[path]) {
      this.paths[path] = new Promise(function (resolve, reject) {
        let elem;
        let href = path + "?cache=" + Date.now();

        if (path.match(/css$/)) {
          elem = document.createElement("link");
          elem.rel = "stylesheet";
          elem.href = href;
        }
        else {
          elem = document.createElement("script");
          elem.src = href;
        }

        elem.onload = resolve;
        elem.onerror = reject;

        document.head.appendChild(elem);
      });
    }

    return this.paths[path];
  };
};

module.exports = Loader;